// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3523":"9ebec91f7267c866","3908":"436678571aaa23a6","4438":"72b48b15783ae6f5"}[chunkId] + ".js";
};